import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const zeissLighthousePlugin = createPlugin({
  id: 'zeiss-lighthouse',
  routes: {
    root: rootRouteRef,
  },
});

export const ZeissLighthousePage = zeissLighthousePlugin.provide(
  createRoutableExtension({
    name: 'ZeissLighthousePage',
    component: () =>
      import('./components/LighthousePageWithTags').then(m => m.LighthousePageWithTags),
    mountPoint: rootRouteRef,
  }),
);